/**
 * Scanning-brackets loading indicator. Four viewfinder corners pulse
 * while a beam sweeps between them — a security-scan motif rather than
 * a generic spinner, matching the product's SAP-security identity and
 * the flat/square Carbon aesthetic (hard right-angle corners, no curves).
 */
export default function LoaderIcon({ size = 48, className = "" }) {
  return (
    <svg
      className={`loader-icon ${className}`}
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      aria-hidden="true"
    >
      <path className="loader-icon-corner loader-icon-corner--1" d="M6 16V8a2 2 0 0 1 2-2h8" />
      <path className="loader-icon-corner loader-icon-corner--2" d="M32 6h8a2 2 0 0 1 2 2v8" />
      <path className="loader-icon-corner loader-icon-corner--3" d="M42 32v8a2 2 0 0 1-2 2h-8" />
      <path className="loader-icon-corner loader-icon-corner--4" d="M16 42H8a2 2 0 0 1-2-2v-8" />
      <line className="loader-icon-sweep" x1="9" y1="0" x2="39" y2="0" />
    </svg>
  );
}
